const base = '/licTickets'
const path = {
    count: `${base}/count`
}
export { path }